import React from 'react';
import './SpotifyPage.css';

export default function SpotifyPage() {
    const playlistUrl = 'https://open.spotify.com/playlist/4zRHeisBLgrMQyEJVzF1pS?si=nnUzh_vrTniUJ88k1r0jNA&pt=26cdd51dca994739d2ac74ff8e1b5650&pi=A6Xvk1epS52rM';

    return (
        <div className="spotify-page">
            <a
                href={playlistUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="spotify-cover"
            >
                <img src="/spotify.jpg" alt="Spotify" className="spotify-cover__img"/>
            </a>

            <a
                href={playlistUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="spotify-cta"
            >
                Participer à la playlist
            </a>
        </div>
    );
}
